import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  SecurityContext,
  ViewEncapsulation,
} from '@angular/core';
import { ITranscriptWord } from '@models/grade-unit/transcript';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-formatted-paragraph',
  template: ` <div [innerHTML]="santizedHTML"></div> `,
  styleUrls: ['./formatted-paragraph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FormattedParagraphComponent implements OnInit {
  @Input() paragraph: ITranscriptWord[] = [];
  @Input() public currentTime: number = 0;
  @Input() public currentTime$: Observable<number>;
  @Input() public mappedHTML: string = '';
  public santizedHTML: SafeHtml;
  private elements = [];

  constructor(
    private domSanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    this.santizedHTML = this.domSanitizer.bypassSecurityTrustHtml(
      this.mappedHTML,
    );
    this.currentTime$.subscribe((time) => {
      if (this.elements.length <= 0) {
        this.elements = this.elementRef.nativeElement.querySelectorAll('.word');
      }
      this.elements.forEach((element, index) => {
        if (index < this.paragraph.length) {
          const transcript = this.paragraph[index];
          if (
            parseFloat(transcript.start) < time &&
            parseFloat(transcript.end) + 0.2 >= time
          ) {
            this.renderer.addClass(element, 'highlight');
          } else {
            this.renderer.removeClass(element, 'highlight');
          }
        }
      });
    });
  }
}
